import { FunctionComponent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { RoutesList } from '../../../../routes/Routes';
import { usePlanningBreachStore } from '../../../../hooks/usePlanningBreachStore';
import { ErrorMessages } from '@types';
import { parseZodErrors, stringFieldSchema, textAreaInputSchema } from '@utils';
import { SELECT_OPTIONS_ERROR } from '../constants/errors';
import { ZodError } from 'zod';
import { ErrorSummary } from '@atoms/*';
import {
  FormTitle,
  NavigationButtons,
  RadioOptions,
  TextArea,
} from '@molecules/*';
import {
  WHO_IS_RESPONSIBLE_ERROR_TEXT,
  WHO_IS_RESPONSIBLE_ERROR_TEXT_MAX_LENGTH_MESSAGE,
  MAX_LENGTH,
} from '../constants/constants';

export const ChangeResponsibility: FunctionComponent = () => {
  const navigate = useNavigate();
  const { data, update, resetSelective } = usePlanningBreachStore();
  const [errorMessages, setErrorMessages] = useState<ErrorMessages[]>([]);
  const title = 'Do you know who is responsible for the change of use? ';
  const moreDetailsLabelText = 'Give more details ';
  const moreDetailsDescription =
    'Include their name and contact details, if you know them.';

  const options = [
    {
      id: 'Yes',
      title: 'Yes',
      labelText: 'Yes',
      isDefault: data.whoIsResponsible === 'Yes',
    },
    {
      id: 'No',
      title: 'No',
      labelText: 'No',
      isDefault: data.whoIsResponsible === 'No',
    },
  ];

  const handleChangeOptions = (selection: string) => {
    setErrorMessages([]);
    const updatedSelection = options.filter(
      (type) => type.labelText === selection,
    )[0].id as 'Yes' | 'No';

    if (updatedSelection) {
      update('whoIsResponsible', updatedSelection);
    } else {
      resetSelective();
    }
  };

  const handleChangeWhoIsResponsible = (
    event: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    update('detailsOfResponsibility', event.currentTarget.value);
    setErrorMessages([]);
  };

  const buttonPrevious = {
    onClick: () => {
      navigate(RoutesList.TELL_US_MORE_CHANGE);
    },
  };

  const buttonNext = {
    onClick: async () => {
      try {
        stringFieldSchema(
          'whoIsResponsible',
          SELECT_OPTIONS_ERROR.required.message,
        ).parse({
          whoIsResponsible: data.whoIsResponsible,
        });
        if (data.whoIsResponsible === 'Yes') {
          textAreaInputSchema({
            fieldName: 'detailsOfResponsibility',
            requiredMessage: WHO_IS_RESPONSIBLE_ERROR_TEXT,
            maxLength: MAX_LENGTH,
            maxLengthMessage: WHO_IS_RESPONSIBLE_ERROR_TEXT_MAX_LENGTH_MESSAGE,
          }).parse({
            detailsOfResponsibility: data.detailsOfResponsibility,
          });
        }
        navigate(RoutesList.CHANGE_PROBLEM);
      } catch (error) {
        const validationErrors = parseZodErrors(error as ZodError);
        setErrorMessages(
          validationErrors.map((error: ErrorMessages) => ({
            ...error,
            path: error.path,
          })),
        );
      }
    },
  };

  return (
    <>
      <div className={' mt-6'}>
        <ErrorSummary messages={errorMessages} />
      </div>
      <FormTitle text={title} />
      <RadioOptions
        options={options}
        onChange={handleChangeOptions}
        errorPath={'whoIsResponsible'}
        errorMessages={errorMessages}
      />
      {data.whoIsResponsible === 'Yes' ? (
        <TextArea
          labelText={moreDetailsLabelText}
          isLabelTextTitle={false}
          description={moreDetailsDescription}
          value={data.detailsOfResponsibility}
          onChange={handleChangeWhoIsResponsible}
          errorPath={'detailsOfResponsibility'}
          errorMessages={errorMessages}
        />
      ) : null}
      <NavigationButtons
        buttonNext={buttonNext}
        buttonPrevious={buttonPrevious}
      />
    </>
  );
};
